import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-clase-explicacion",
  templateUrl: "./clase-explicacion.component.html",
  styleUrls: ["./clase-explicacion.component.scss"],
})
export class ClaseExplicacionComponent implements OnInit {
  @Input() public DATA: any;
  @Input() public curso: any;
  @Input() public ID_TIPO_LC: any;
  @Output() public isvalid = new EventEmitter<boolean>();
  @Output() public name = new EventEmitter<string>();
  host: string;
  urlVideo: string;
  image: string;
  embedUrl: any;
  constructor(private sanitizer: DomSanitizer) {}

  respuesta: string = "";
  ngOnInit() {
    this.name.emit("Clase Explicación");
    this.urlVideo = this.DATA.link_video;
    console.log("🚀 ~ ClaseExplicacionComponent ~ ngOnInit ~ this.urlVideo:", this.urlVideo)
    this.image = environment.host + "/" + this.DATA.recurso;
    console.log("🚀 ~ ClaseExplicacionComponent ~ ngOnInit ~ this.image:", this.image)
    this.host = environment.host + "/";
    if (this.urlVideo != "null") {
      this.embedVideo();
    }
    this.isvalid.emit(true);
  }

  embedVideo() {
    const youtubeRegex =
      /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    if (youtubeRegex.test(this.urlVideo)) {
      const videoId = this.urlVideo.match(youtubeRegex)[1];
      this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${videoId}`
      );
    } else {
      this.embedUrl = null;
    }
  }
}
